import React, { useCallback, useEffect, useState } from 'react'

import { KEY_VALUES } from '../../constants'
import { useTranslation } from '../../contexts/I18nContext'
import { encodeRecipeSlug } from '../../helpers'
import { THEME } from '../../styles'
import Icon from '../Icon'

import Styled from './RecipeActions.styled'

const RecipeActions = ({
  accessToken,
  className,
  displayMenuEdition,
  editMenu,
  favorRecipe,
  favoriteRecipes,
  isLoading,
  isRecipeAdded,
  oldRecipeId,
  openModal,
  recipe,
  title,
}) => {
  const { t } = useTranslation()

  const handleShareRecipe = useCallback(() => {
    if (!isLoading) {
      const messageTitle = title || recipe.title
      const messageDescription = recipe.description || recipe.descriptionSEO
      const message = `${messageTitle}${
        messageDescription ? `- ${messageDescription}` : ''
      }`
      openModal('ShareUrl', { message, url: window.location.href })
    }
  }, [
    isLoading,
    title,
    recipe.title,
    recipe.description,
    recipe.descriptionSEO,
    openModal,
  ])

  const handleAdd = useCallback(() => {
    if (accessToken) {
      editMenu(oldRecipeId || 'add', recipe, 'recipe')
    } else {
      openModal('Login')
    }
  }, [accessToken, editMenu, oldRecipeId, recipe, openModal])
  const handleRemove = useCallback(() => {
    editMenu(recipe.id, 'delete')
  }, [editMenu, recipe.id])

  const [isFavored, setIsFavored] = useState(false)
  useEffect(() => {
    setIsFavored((favoriteRecipes || []).includes(recipe.id))
  }, [favoriteRecipes, recipe.id])

  return (
    <Styled className={className} displayMenuEdition={displayMenuEdition}>
      {displayMenuEdition ? (
        <Styled.buttons>
          {isRecipeAdded ? (
            <Styled.remove
              size="tiny"
              onClick={handleRemove}
              disabled={isLoading}
            >
              {t('RECIPE.REMOVE')}
            </Styled.remove>
          ) : (
            <Styled.addOrChoose
              size="tiny"
              onClick={handleAdd}
              disabled={isLoading}
            >
              {oldRecipeId ? t('MENU.CHOOSE_MEAL') : t('RECIPE.ADD')}
            </Styled.addOrChoose>
          )}
        </Styled.buttons>
      ) : null}

      <Styled.icons>
        <Styled.share>
          <Styled.shareButton
            role="button"
            tabIndex={0}
            onClick={handleShareRecipe}
            onKeyPress={(event) => {
              if (event.key === KEY_VALUES.ENTER) {
                handleShareRecipe()
              }
            }}
            isLoading={isLoading}
            disabled={isLoading}
          >
            <Styled.shareIcon
              name="share-ios-24"
              width={24}
              height={24}
              fill={
                isLoading
                  ? THEME.COLORS.foreground.secondary
                  : THEME.COLORS.foreground.primary
              }
            />
          </Styled.shareButton>
        </Styled.share>
        <Styled.print
          to={`${
            recipe.source === 'user-generated' ? '/user-recipes' : '/recipes'
          }/${encodeRecipeSlug({
            id: recipe.id,
            slug: recipe.slug,
          })}/print?coversCount=${recipe.coversCount}`}
          isLoading={isLoading}
          disabled={isLoading}
        >
          <Icon
            name="print-24"
            width={24}
            height={24}
            fill={
              isLoading
                ? THEME.COLORS.foreground.secondary
                : THEME.COLORS.foreground.primary
            }
          />
        </Styled.print>
        <Styled.like
          isLoading={isLoading}
          value={isFavored}
          count={recipe.likes}
          onClick={() =>
            favorRecipe({
              id: recipe.id,
              title: recipe.title,
              source: recipe.source,
            })
          }
        />
      </Styled.icons>
    </Styled>
  )
}

RecipeActions.defaultProps = {
  recipe: {},
  displayMenuEdition: true,
}

export default RecipeActions
